<template>
    <Modal title="修改密码" v-model="show" :closable="false" :mask-closable="false">
        <el-form ref="mchForm" label-position="right" label-width="120px" :model="mch" :rules="pwdRules">
            <el-form-item label="新登录密码" prop="pwd">
                <el-input type="password" v-model="mch.pwd" placeholder="新登录密码" style="width: 240px" />
            </el-form-item>
            <el-form-item label="重复新登录密码" prop="cfpwd">
                <el-input type="password" v-model="mch.cfpwd" placeholder="重复新登录密码" style="width: 240px" />
            </el-form-item>
            <el-form-item label="新支付密码" prop="paypwd">
                <el-input type="password" v-model="mch.paypwd" placeholder="新支付密码" style="width: 240px" />
            </el-form-item>
            <el-form-item label="重复新登录密码" prop="cfpaypwd">
                <el-input type="password" v-model="mch.cfpaypwd" placeholder="重复支付新密码" style="width: 240px" />
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button size="small" type="primary" :loading="modalLoading" @click="ok">确定</el-button>
        </div>
    </Modal>
</template>
<script>
export default {
    name: 'CPassword',
    data() {
        return {
            modelShow: true,
            modalLoading: false,
            pwdRules: {

            },
            mch: {
                cfpaypwd: "",
                paypwd: "",
                pwd: "",
                cfpwd: ""
            }

        };
    },
    props: [
        'userId', 'show'
    ],
    mounted: function() {


    },
    methods: {
        ok: function() {

            if (this.mch.pwd != "" && this.mch.pwd != this.mch.cfpwd) {
                this.$Message.error("两次登录密码不一致");
                return;
            }
            if (this.mch.paypwd != "" && this.mch.paypwd != this.mch.cfpaypwd) {
                this.$Message.error("两次支付密码不一致");
                return;
            }
            if (this.mch.pwd == "" && this.mch.paypwd == "") {
                this.$emit('ok');
                return;
            }
            var me = this;
            var params={userId:me.userId};
            params['passport']=me.mch.pwd;
            params['cfPassport']=me.mch.cfpwd;
            params['payPassport']=me.mch.paypwd;
            params['cfPayPassport']=me.mch.cfpaypwd;
            me.$http.post("/sys/merchant/dopwd.action", params).then(response => {
                var body = response;
                if (body.status == 0) {

                    me.$Message.info("操作成功");

                    me.$emit('ok');

                } else {
                    me.$Message.error("操作异常!" + body.info);
                }
            }, response => {

            });

        },
        cancel: function() {

            this.$emit('cancel');
        }
    }
}
</script>